import React from 'react'

type Props = {
    value: string
    onChange: (value: string) => void
    changeName: string
}

export default function ViewType(props: Props) {
    const { value, onChange, changeName } = props

    return (
        <div className='text-sm text-gray-500'>
            Viewing:
            <select className='ml-3' value={value} onChange={(e) => onChange(e.target.value)}>
                <option value='all'>All</option>
                <option value='unchanged'>Not {changeName}</option>
                <option value='changed'>{changeName}</option>
                <option value='error'>All Errors</option>
                <option value='my-error'>My Errors</option>

            </select>
        </div>
    )
}
